import { render } from "./nxAreaSelect.vue?vue&type=template&id=3805ee28"
import script from "./nxAreaSelect.vue?vue&type=script&lang=js"
export * from "./nxAreaSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__